export const PRIORITY_TIERS = [
  { tier: 1, label: "Tier 1", badge: "error" },
  { tier: 2, label: "Tier 2", badge: "warning" },
  { tier: 3, label: "Tier 3", badge: "default" },
];
export const PRIORITY_META = Object.fromEntries(PRIORITY_TIERS.map((p) => [p.tier, p]));
export const UNCLASSIFIED_TIER = "unclassified";
export const UNCLASSIFIED_META = { label: "Archived", badge: "default" };

export const REMOVED_TIER = "removed";
export const REMOVED_META = { label: "Removed", badge: "default" };

export const ALL_TIER_KEYS = [...PRIORITY_TIERS.map((p) => p.tier), UNCLASSIFIED_TIER, REMOVED_TIER];

// Archived/Removed are opt-in: the default view is active candidates only.
export const DEFAULT_TIER_KEYS = PRIORITY_TIERS.map((p) => p.tier);

// Normalizes a raw candidate row into a stable key for filter-set
// membership. removed_at wins over priority, same precedence as
// outreachStatusMetaFor.
export const tierKeyFor = ({ priority, removed_at } = {}) =>
  removed_at != null ? REMOVED_TIER : priority == null ? UNCLASSIFIED_TIER : priority;

export const priorityMetaFor = (priority) => (priority == null ? UNCLASSIFIED_META : PRIORITY_META[priority]);

export const outreachStatusMetaFor = ({ priority, removed_at } = {}) =>
  removed_at != null ? REMOVED_META : priorityMetaFor(priority);
